import React from "react";
import PageHero from "../components/PageHero";
import CTABanner from "../components/CTABanner";
import { INDUSTRIES } from "../data/site";
import { ArrowUpRight } from "lucide-react";

export default function IndustriesServed() {
  return (
    <div data-testid="page-industries-served">
      <PageHero
        eyebrow="Industries Served"
        title="Service delivery across public, commercial, and institutional sectors."
        intro="Street Society supports a broad range of operational environments — from federal facilities and municipal grounds to commercial properties, educational campuses, and healthcare administrative spaces."
        image="campus"
      />

      <section className="section-y bg-white" data-testid="industries-grid">
        <div className="container-x">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[#E2E8F0] border border-[#E2E8F0]">
            {INDUSTRIES.map((ind, i) => (
              <article
                key={ind.title}
                className="bg-white p-8 lg:p-9 flex flex-col gap-4 card-hover group"
                data-testid={`industry-card-${i}`}
              >
                <div className="flex items-center justify-between">
                  <span className="text-overline text-[#9BB7A2]">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <ArrowUpRight
                    size={18}
                    className="text-[#9CA5B0] group-hover:text-[#4B7055] transition-colors"
                    strokeWidth={1.75}
                  />
                </div>
                <h3 className="font-serif text-xl text-[#0A1F35] font-bold leading-snug">{ind.title}</h3>
                <p className="text-sm text-[#4A5568] leading-relaxed flex-1">{ind.desc}</p>
                <div className="pt-5 border-t border-[#E2E8F0]">
                  <span className="text-xs text-[#4A5568]">
                    Capabilities: Facility · Grounds · Mechanical · Procurement Support
                  </span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-[#F5F7F9] section-y" data-testid="industries-cta">
        <div className="container-x text-center max-w-3xl mx-auto">
          <p className="text-overline text-[#4B7055] mb-4">Expanding Sector Coverage</p>
          <h2 className="heading-section text-3xl sm:text-4xl text-[#0A1F35]">
            Don’t see your sector listed? Street Society is built to expand.
          </h2>
          <p className="mt-5 text-[#4A5568] leading-relaxed">
            Our capability framework is intentionally broad — designed to support additional industries
            and contract structures as client needs evolve. Reach out to discuss your environment.
          </p>
        </div>
      </section>

      <CTABanner />
    </div>
  );
}
